/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { UFOExperience, ExperienceTypes, ExperiencePerformanceTypes } from '@atlassian/ufo';

export const CreateIssueUFOExperience: UFOExperience = new UFOExperience(
	'global-issue-create.create-issue',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.Custom,
		category: 'global-issue-create.create-issue',
	},
);

export const EditIssueTypeUFOExperience: UFOExperience = new UFOExperience(
	'global-issue-create.create-issue.issue-type-field.edit-issue-type',
	{
		type: ExperienceTypes.Operation,
		performanceType: ExperiencePerformanceTypes.Custom,
	},
);

export const CreateIssueTypeUFOExperience: UFOExperience = new UFOExperience(
	'global-issue-create.create-issue.issue-type-field.create-issue-type',
	{
		type: ExperienceTypes.Operation,
		performanceType: ExperiencePerformanceTypes.Custom,
	},
);

export const StatusFieldLoad: UFOExperience = new UFOExperience(
	'global-issue-create.create-issue.status-field',
	{
		type: ExperienceTypes.Load,
		performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
	},
);

export const GlobalIssueCreateModalSubmitUFOExperience: UFOExperience = new UFOExperience(
	'modern-global-issue-create.modal.issue-submit',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
		category: 'modern-global-issue-create.modal.issue-submit',
	},
);

export const EcosystemAPIPrefillingUFOExperience: UFOExperience = new UFOExperience(
	'ecosystem-api-new-gic-prefilling',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.Custom,
		category: 'ecosystem-api-new-gic-prefilling',
	},
);
